/**
 * @author Harshitha.k
 * @description 
 */

import axios from 'axios';
import dayjs from 'dayjs';
import constant from './constant';
import GraphView from './GraphView';
import { connect } from 'react-redux';
import React, { useState, useEffect, useRef } from 'react';
import HierarchyModal from './HierarchyModal';
import Highlighter from 'react-highlight-words';
import localStorage from '../../utils/localStorage';
import { API_DEVICE, FFT } from '../../commons/api.js';
import StyledTable from '../../commons/styles/table.js';
import themeSettings from '../../commons/styles/themeSettings.json';
import {
  Button,
  Popconfirm,
  Tooltip,
  Input,
  DatePicker,
  Modal,
  Form,
  message,
  Checkbox,
} from 'antd';
import {
  BarChartOutlined,
  DoubleLeftOutlined,
  SearchOutlined,
  UpSquareOutlined
} from '@ant-design/icons';

const { RangePicker } = DatePicker;

const FormGenerator = (props) => {
  const [dataSource, setDataSource] = useState([]);
  const [optionList, setOptionList] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [dateTimeRange, setDateTimeRange] = useState([]);
  const [isGenerate, setIsGenerate] = useState(false);
  const [Device, setDevice] = useState('');
  const [deviceList, setDeviceList] = useState([]);
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);
  const [language, setLanguage] = useState(props.language);
  const [graphData, setGraphData] = useState({});
  const [selectedGraph, setSelectedGraph] = useState({});
  const [curentPage, setCurentPage] = useState(1);
  const [deviceId, setDeviceId] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [formObject] = useState({});
  const [hierarchy, setHierarchy] = useState([]);
  const [searchText, setSearchText] = useState('');
  const hRef = useRef();
  const searchInput =useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      if (props && props.location) {
        let searchParams = new URLSearchParams(props.location.search);
        let newParams = Object.fromEntries([...searchParams]);
        setDeviceId(newParams.deviceCode);
      }
      await getDeviceList();
      await _getOptionList();
      await getHierarchyLevels();
    };
    fetchData();
  }, [props]);

  useEffect(() => {
    if (props.translationCache !== translationCache || props.language !== language) {
      setTranslationCache(props.translationCache);
      setLanguage(props.language);
    }
  }, [props.translationCache, props.language]);

  const _getOptionList = () => {
    let options = JSON.parse(localStorage.get('modules')) || [];
    setOptionList(options && options.hierarchy ? options.hierarchy : optionList);
  };

  const getDeviceList = async () => {
    let siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const headers = {
      method: 'GET',
      url: `${API_DEVICE.LIST}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    try {
      const res = await axios(headers);
      setDeviceList(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getHierarchyLevels = async () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let options = JSON.parse(localStorage.get('modules')) || [];
    const payload = {
      HierarchyCode: options.hierarchy[0].HierarchyCode,
      Type: 'Asset',
    };
    const headers = {
      method: 'GET',
      url: `/api/hierarchymodule/getHierarchyLevels?HierarchyCode=${payload.HierarchyCode}&SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };
    try {
      const { data } = await axios(headers);
      setHierarchy(data);
    } catch (error) {
      console.log(error);
    }
  };

  const generateRecord = async (record) => {
    const accessToken = localStorage.get('accessToken');
    const headers = {
      method: 'POST',
      url: `${FFT.Generate}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: {
        Device: record.Device,
        FileName: [record.FileName]
      }
    };
    try {
      const res = await axios(headers);
      if (res && res.data && res.data.message) {
        message.success(res.data.message);
      }
      submitFile(record);
    } catch (error) {
      console.log(error);
    }
  };

  const graphView = async (record) => {
    let siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const headers = {
      method: 'POST',
      url: `${FFT.Show}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: {
        Device: record && record.DeviceAlias ? record.DeviceAlias : '',
        FileName: [record.FileName]
      }
    };
    try {
      const res = await axios(headers);
      setModalVisible(true);
      setGraphData(res.data[0] && res.data[0]);
      setSelectedGraph(record);
    } catch (error) {
      if (error.response.status === 400 || error.response.status === 500) {
        message.info(error.response.data.message);
      }
    }
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        {dataIndex === 'TimeStamp' ? (
          <DatePicker
            showTime={{ format: 'HH:mm' }}
            format="DD-MM-YYYY HH:mm"
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(value) => setSelectedKeys(value ? [value] : [])}
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
        ) : (
          <Input
            ref={searchInput}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
        )}

        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          
          style={{ width: 90, marginRight: 8 }}
        >
          <SearchOutlined /> Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)}  style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record && record[dataIndex] && dataIndex === 'device'
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : record && record[dataIndex] && dataIndex === 'TimeStamp'
        ? dayjs(record['dataIndex']).format('DD-MM-YYYY HH:mm')
        : '',
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  const handleSearch = (selectedKeys, confirm, column) => {
    confirm();
    if (column === 'TimeStamp') {
      setSearchText(dayjs(selectedKeys[0]).format('DD-MM-YYYY HH:mm'));
    } else {
      setSearchText(selectedKeys[0]);
    }
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const submitFile = async () => {
    let siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const headers = {
      method: 'POST',
      url: `${FFT.GetFiles}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: {
        Device: Number(Device) ? Number(Device) : '',
        StartDate: dayjs.utc(dateTimeRange[0]).format('YYYY-MM-DD HH:mm:ss'),
        EndDate: dayjs.utc(dateTimeRange[1]).format('YYYY-MM-DD HH:mm:ss'),
        isGenerate: isGenerate
      }
    };
    try {
      const res = await axios(headers);
      setDataSource(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const onFinish = async (values) => {
    if (deviceId) {
      let siteId = localStorage.get('currentSite');
      const accessToken = localStorage.get('accessToken');
      const headers = {
        method: 'POST',
        url: `${FFT.GetFiles}?SiteId=${siteId}`,
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        data: {
          Device: deviceId,
          StartDate: dayjs(values.dateTimeRange[0]).utc().format('YYYY-MM-DD HH:mm:ss'),
          EndDate: dayjs(values.dateTimeRange[1]).utc().format('YYYY-MM-DD HH:mm:ss'),
          isGenerate: values.isGenerate
        }
      };
      try {
        const res = await axios(headers);
        if (res && res.data && Array.isArray(res.data) && res.data.length <= 0) {
          message.error('No Data Found');
        } else if (res && res.data && res.data.message) {
          message.error(res.data.message);
        } else {
          message.success('Data Found');
        }
        setDataSource(res.data);
        setDateTimeRange(values.dateTimeRange);
        setIsGenerate(values.isGenerate);
        setDevice(values.deviceId);
        setCurentPage(1);
      } catch (error) {
        console.log(error);
      }
    } else {
      message.error('Please select sensor !!');
    }
  };

  const onFinishFailed = () => {
    message.error('Please enter mandatory fields');
  };

  const close = () => {
    setModalVisible(false);
  };

  const hierarchyDropdownChange = (deviceId) => {
    setDeviceId(deviceId);
    setIsModalVisible(false);
  };

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };
  const disabledDate = (current) => {
    return current > dayjs().endOf('day');
  };

  const columns = [
    {
      title: translation(constant.device),
      dataIndex: 'Device',
      key: 'Device',
      ...getColumnSearchProps('Device'),
      render: (text) => {
        let filteredDevice = deviceList.filter((device) => device.AliasCode === text);
        return (
          <div>
            {filteredDevice[0] ? `${filteredDevice[0].DeviceCode}` : text}
          </div>
        );
      }
    },
    {
      title: translation(constant.timestamp),
      dataIndex: 'TimeStamp',
      key: 'TimeStamp',
      sorter: (a, b) => dayjs(a.TimeStamp) - dayjs(b.TimeStamp),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('TimeStamp'),
      render: (text) => (
        <div>{dayjs.utc(text, 'YYYY-MM-DD HH:mm:ss').local().format('YYYY-MM-DD HH:mm:ss')}</div>
      )
    },
    {
      title: translation(constant.filename),
      dataIndex: 'FileName',
      key: 'FileName'
    },
    {
      title: translation(constant.fftgenerateddate),
      dataIndex: 'FFTGeneratedDate',
      key: 'FFTGeneratedDate'
    },
    {
      title: translation(constant.status),
      dataIndex: '',
      key: '',
      render: (text, record) => (
        <div>
          {record.Status === 'GENERATE' ? (
            <Popconfirm
              title={'Do you want to Generate ?'}
              onConfirm={() => generateRecord(record)}
              onCancel={() => {}}
              okText="Yes"
              cancelText="No"
            >
              <Button
                type="primary"
                disabled={ record && record.Status === 'Done'}
              >
                Generate
              </Button>
            </Popconfirm>
          ) : (
            <Tooltip placement="top" title="Graph View">
              <Button
                type="button"
                style={{ marginLeft: '10px' }}
                onClick={() => graphView(record)}
              >
                <BarChartOutlined width="50em" style={{ color: '#40a9ff' }} />
              </Button>
            </Tooltip>
          )}
        </div>
      )
    }
  ];

  const handlePagination = (current) => {
    setCurentPage(current);
  };

  const validateMessages = {
    required: '${label} is required!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!'
    },
    number: {
      range: '${label} must be between ${min} and ${max}'
    },
    pattern: {
      mismatch: '${label} does not match pattern'
    }
  };
  const filteredDevice =
      deviceId && deviceList
        ? deviceList.filter((device) => device.DeviceCode.toString() === deviceId)
        : '';

  return (
    <div style={{ minHeight: window.innerHeight - 69, padding: '0px 15px' }}>
      <>
        <Button
          style={{ marginTop: '10px' }}
          type={'primary'}
          onClick={() => props.navigate(-1)}
        >
          <DoubleLeftOutlined />
          {translation('Go Back')}
        </Button>
        <Form
          layout={'inline'}
          ref={hRef}
          initialValues={formObject ||{}}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          style={{ margin: '36px 0px' }}
          theme={themeSettings}
          validateMessages={validateMessages}
        >
          <Form.Item
            label={translation(constant.device)}
            name="deviceId"
            initialValue={deviceId}
            rules={[{ required: false }]}
            style={{ display: 'inline-block', width: '500px' }}
          >
            <span style={{ marginTop: '10px' }}>
              <Input
                placeholder={translation('Select sensor')}
                value={
                  filteredDevice &&
                  Array.isArray(filteredDevice) &&
                  filteredDevice[0] &&
                  filteredDevice[0].Name
                    ? `${translation(filteredDevice[0].Name)}${
                      translation(filteredDevice[0].DeviceCode)
                          ? `-${translation(filteredDevice[0].DeviceCode)}`
                          : ''
                      }  `
                    : ''
                }

                style={{ width: '330px', display: 'inline-block' }}
              />
              <Button
                type="primary"
                onClick={() => setIsModalVisible(true)}
              >
                <UpSquareOutlined />
              </Button>
              <Modal
                title={translation(constant.SELECT_HIERARCHY)}
                className="hierarchyModal"
                open={isModalVisible}
                footer={null}
                onCancel={() => setIsModalVisible(false)}
              >
                <HierarchyModal
                  handleDropdownChange={hierarchyDropdownChange}
                  treeData={hierarchy}
                />
              </Modal>
            </span>
          </Form.Item>
          <Form.Item
            label={translation(constant.timestamprange)}
            name="dateTimeRange"
            initialValue={[dayjs().subtract(1, 'hour'), dayjs()] || []}
            rules={[{ required: true }]}
          >
            <RangePicker
              showTime={{ format: 'HH:mm' }}
              format="YYYY-MM-DD HH:mm"
              placeholder={['Start DateTime', 'End DateTime']}
              style={{ width: "500px" }}
              disabledDate={disabledDate}
            />
          </Form.Item>
          <Form.Item label={''} name="isGenerate" valuePropName="checked" initialValue={true}
            style={{ display: 'inline-block', marginRight: '20px' }}
          >
            <Checkbox>
              <span style={{ color: 'white', display: 'inline-block' }}>
                {translation(constant.showonlygenerated)}
              </span>
            </Checkbox>
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              {translation(constant.submit)}
            </Button>
          </Form.Item>
        </Form>

        <StyledTable size="small"
          columns={columns}
          dataSource={dataSource.length > 0 ? dataSource : []}
          pagination={{
            current: curentPage,
            defaultPageSize: 10,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '30'],
            onChange: handlePagination
          }}
        />
        <Modal
          title={`${selectedGraph.Device} (${selectedGraph.TimeStamp})`}
          centered
          width="1600px"
          open={modalVisible}
          onCancel={close}
          footer={null}
        >
          <GraphView
            panelData={{
              graph: 'trends',
              trendData: graphData
            }}
            translationCache={props.translationCache}
            language={props.language}
          />
        </Modal>
      </>
    </div>
  );
};

const mapStateToProps = (state) => ({
  language: state.TranslationReducer.language,
  translationCache : state.TranslationReducer.translationCache
});

export default connect(mapStateToProps)(FormGenerator);